import EnvironmentalAspectsAssessmentAspectCard from './Aspect/EnvironmentalAspectsAssessmentAspectCard';
import EnvironmentalAspectsAssessmentInspectionCard from './Inspection/EnvironmentalAspectsAssessmentInspectionCard';

export default function EnvironmentalAspectsAssessmentCardSwitch({
  id,
  type,
}) {
  switch (type) {
    case 'sacyrAspect':
      return <EnvironmentalAspectsAssessmentAspectCard aspectID={id} />;
    case 'sacyrInspection':
      return <EnvironmentalAspectsAssessmentInspectionCard id={id} />;

    default:
      return '';
  }
}
